import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/curators",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          requiresAuth: true,
          title: "Dashboard",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/curators",
        name: "curators",
        component: () => import("@/curators/views/Curators.vue"),
        meta: {
          title: "Curators",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/curator-detail/:chartmetricCuratorID",
        name: "curatorDetail",
        component: () => import("@/curators/views/CuratorDetail.vue"),
        meta: {
          title: "Curator Detail",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/playlists",
        name: "playlists",
        component: () => import("@/playlists/views/Playlists.vue"),
        meta: {
          title: "Playlists",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/playlist-detail/:curatorPlaylistID",
        name: "playlistDetail",
        component: () => import("@/playlists/views/PlaylistDetail.vue"),
        meta: {
          title: "Playlist Detail",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/track-detail/:chartmetricTrackID",
        name: "TrackDetail",
        component: () => import("@/playlistTracks/views/TrackDetail.vue"),
        meta: {
          title: "Track Detail",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/explore/",
        name: "SearchResults",
        component: () => import("@/user/views/SearchResults.vue"),
        meta: {
          title: "Search Result",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/artist-detail/:chartmetricArtistID",
        name: "ArtistDetail",
        component: () => import("@/artist/views/ArtistDetail.vue"),
        meta: {
          title: "Artist Detail",
          version: "v2",
          headerFixed: false,
        },
      },
      {
        path: "/wishlist-detail/:wishlistID",
        name: "WishlistID",
        component: () => import("@/wishlists/WishlistDetail.vue"),
        meta: {
          title: "Wishlist Detail",
          version: "v2",
          headerFixed: false,
        },
      },
    ],
  },

  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/error/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/error/Error500.vue"),
  },

  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
